import React from 'react';
import { trackEvent } from '../utils/metaPixel';
export function FinalCTA() {
  const handleCtaClick = () => {
    trackEvent('Lead', {
      content_name: 'Final CTA',
      content_category: 'landing_page'
    });
  };
  return <section className="py-20 px-4 relative overflow-hidden bg-pink-400" data-id="element-69">
      <div className="absolute inset-0 bg-confetti opacity-30 pointer-events-none mix-blend-overlay" data-id="element-70"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center text-white" data-id="element-71">
        <h2 className="text-4xl md:text-6xl font-bold mb-6 font-baloo drop-shadow-md" data-id="element-72">
          🔥 ¿LISTA PARA CREAR LA FIESTA DE TUS SUEÑOS?
        </h2>

        <p className="text-xl md:text-2xl mb-10 font-medium opacity-90 max-w-2xl mx-auto" data-id="element-73">
          No dejes que otro cumpleaños pase sin la magia que tu peque merece.
          Por menos de lo que cuesta un globo de helio, tienes acceso a todo lo
          que necesitas.
        </p>

        <div className="bg-white text-gray-900 rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto transform hover:scale-[1.02] transition-transform border-4 border-pink-200" data-id="element-74">
          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-75">
            <span className="text-3xl text-gray-400 line-through font-bold" data-id="element-76">
              47€
            </span>
            <span className="text-6xl font-bold text-magenta font-baloo" data-id="element-77">
              17€
            </span>
          </div>

          <a href="#pricing" onClick={handleCtaClick} className="block w-full bg-pink-500 text-white font-baloo font-bold text-2xl md:text-3xl py-5 px-8 rounded-full shadow-[0_8px_0_#D81B60] hover:shadow-[0_4px_0_#D81B60] hover:translate-y-1 transition-all duration-200 mb-6" data-id="element-78">
            👇 QUIERO MI KIT FIESTA MÁGICA 👇
          </a>

          <p className="text-sm md:text-base font-bold text-gray-500 uppercase tracking-wider" data-id="element-79">
            ⚡ Acceso inmediato · Pago único · Sin suscripciones
          </p>
          <p className="text-sm text-gray-400 mt-2 italic" data-id="element-80">
            Tu kit llega a tu email en minutos 🎉
          </p>
        </div>
      </div>
    </section>;
}